import { useDispatch, useSelector } from "react-redux";
import { uploadFileAction } from "../../../redux/actions/GlobalAction";
import { getInfrastructureDetailsAction } from "../../../redux/actions/InfrastructureDetailsAction";
import { getSnackbarSuccess } from "../../../Utils/helper";
import { removeImageHandler } from "../CommonComponent/commonfunctionality";

export const FacilityImageMultiple = ({
  imageArray,
  heading,
  docType,
  headingSub,
  imageUploadLength,
}) => {
  const dispatch = useDispatch();
  const isPageEdit = useSelector((state) => state?.globalReducer?.isPageEdit);
  return (
    <div className="row align-items-center flex-wrap facility-images-item">
      <div className="col-md-3">
        <h3>{heading}</h3>
        <h3 className="mt-1">{headingSub}</h3>
      </div>
      <div className="col-md-9 d-flex flex-wrap align-items-center">
        {imageArray?.map((ele, index) => {
          return (
            <p className="img-text" key={index}>
              <a
                className="upload-img me-2 img-name"
                target="blank"
                href={ele?.imageUrl}
              >
                {ele?.imageUrl && `${heading}-${index + 1}`}
              </a>
              {isPageEdit && (
                <img
                  src="https://live.healthassure.in/ProvidersPortal/images/removeicon.png"
                  type="button"
                  onClick={async () => {
                    await removeImageHandler(
                      ele,
                      getInfrastructureDetailsAction,
                      true,
                      dispatch
                    );
                  }}
                  alt=""
                />
              )}
            </p>
          );
        })}
        {imageArray?.length <= imageUploadLength && (
          <label className="btn btn-primary" style={{ cursor: "pointer" }}>
            <input
              type="file"
              id="imageUpload"
              style={{ width: "2px" }}
              name={docType}
              accept="image/jpeg, image/jpg, image/png"
              onChange={async (e) => {
                const file = e.target.files[0];
                if (file.size > 2097152) {
                  getSnackbarSuccess(
                    "info",
                    "Maximum upload file size is 2 MB.",
                    dispatch
                  );
                } else if (
                  file.type !== "image/jpg" &&
                  file.type !== "image/jpeg" &&
                  file.type !== "image/png"
                ) {
                  getSnackbarSuccess(
                    "info",
                    "File Types allowed are JPG, JPEG, PNG.",
                    dispatch
                  );
                } else {
                  await dispatch(
                    uploadFileAction(e.target.files[0], docType, dispatch)
                  );
                  await dispatch(getInfrastructureDetailsAction());
                }
              }}
              disabled={!isPageEdit}
            />
            <span style={{ cursor: !isPageEdit && "auto" }}>
              <img src="./images/uploadicon.svg" alt="" /> UPLOAD
            </span>
          </label>
        )}
      </div>
    </div>
  );
};
